import { getCoreRowModel, getSortedRowModel, SortingState, useReactTable } from "@tanstack/react-table";
import { useState } from "react";
import { ListFilterParams } from "components/typings";
import { TaskBase } from "pages/project/common/taskBase.typing";
import { DataTable } from "../../../../components/Datatable/DataTable";
import { useTaskListTable } from "../hooks/useTaskListTable";
import { TaskListType } from "../task.typing";

interface TaskListTableProps {
  tasks: TaskBase[];
  shownDetailDataId?: string;
  filterParams: ListFilterParams<TaskBase>;
  isUserSupplier: boolean;
  taskListType: TaskListType;
}

export function TaskListTable({
  tasks,
  shownDetailDataId,
  filterParams,
  isUserSupplier,
  taskListType,
}: TaskListTableProps) {
  const { columns } = useTaskListTable({ filterParams, isUserSupplier, taskListType });

  const [sorting, setSorting] = useState<SortingState>([]);

  const table = useReactTable<TaskBase>({
    data: tasks,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    onSortingChange: setSorting,
    state: {
      sorting,
    },
  });

  return <DataTable table={table} type="task" shownDetailDataId={shownDetailDataId} stickyHeader />;
}
